import { createI18n } from "vue-i18n";
import zhCN from "./locales/zh-cn.json";
import zhTW from "./locales/zh-tw.json";
import en from "./locales/en.json";
import pt from "./locales/pt.json";
import { getInitialLanguage, getI18nLocale } from '@/utils/languageUtils'

// 获取上次保存的语言设置或系统默认语言
const savedLanguage = getInitialLanguage()
const locale = getI18nLocale(savedLanguage)

const i18n = createI18n({
  legacy: false, // 默认使用 composition API，不启用旧版的 API 兼容模式，是 vue-i18n v9 引入的，为了更好地与 Vue 3 的设计理念保持一致。使用 Composition API 可以提供更灵活的代码组织和更好的类型支持。
  locale, // 使用转换后的locale
  fallbackLocale: "zh-TW",  // 找不到对应的语言时，使用 fallbackLocale对应的语言
  messages:{
    'zh-CN': zhCN, // 提供的简体中文语言
    "zh-TW": zhTW, // 提供的繁体中文语言
    en, // 提供的英文语言
    pt, // 提供的葡萄牙语言
  },
  silentTranslationWarn: true,  // 添加这行来抑制警告
  missingWarn: false,  // 添加这行来抑制缺失警告
});
 
export const globalT = i18n.global.t;
export default i18n;